import {format, parseISO} from "date-fns";

const formatDateTime = (datetime) => {
    if (!datetime) return "";
    try {
        const date = parseISO(datetime);
        if (isNaN(date.getTime())) return datetime;
        return format(date, "dd/MM/yyyy HH:mm")
    } catch (e) {
        return datetime;
    }
}

export const renderStationTooltip = (feature) => {
    const {properties} = feature;

    return <div>
        <div><strong>{properties?.code} - {properties?.name}</strong></div>
        {properties?.elevation !== null && <div>Quota: {properties?.elevation} m</div>}
    </div>
}

export const renderModel1Tooltip = (feature) => {
    const {properties} = feature;

    return <div>
        <div><strong>{properties?.code} - {properties?.name}</strong></div>
        {properties?.elevation !== null && properties?.elevation !== undefined && <div>Quota: {properties?.elevation} m</div>}
        {typeof properties?.hn_avg === 'number' && <div>HN: {properties?.hn_avg.toFixed(2)}</div>}
        {typeof properties?.hs_avg === 'number' && <div>HS: {properties?.hs_avg.toFixed(2)}</div>}
        {typeof properties?.ta_avg === 'number' && <div>TA: {properties?.ta_avg.toFixed(2)}</div>}
        {typeof properties?.th10_avg === 'number' && <div>TH10: {properties?.th10_avg.toFixed(2)}</div>}
        {typeof properties?.th30_avg === 'number' && <div>TH30: {properties?.th30_avg.toFixed(2)}</div>}
        {typeof properties?.t_max_avg === 'number' && <div>T Max: {properties?.t_max_avg.toFixed(2)}</div>}
        {typeof properties?.t_min_avg === 'number' && <div>T Min: {properties?.t_min_avg.toFixed(2)}</div>}
        {typeof properties?.t_gradient_avg === 'number' && <div>T Gradient: {properties?.t_gradient_avg.toFixed(2)}</div>}
    </div>
}

export const renderMicrozoneTooltip = (feature) => {
    const {properties} = feature;

    return <div>
        <div><strong>{properties?.code} - {properties?.name}</strong></div>
        {properties?.l1_max !== null && <div>L1 Max: {properties?.l1_max}</div>}
        {properties?.l1_mode !== null && <div>L1 Mode: {properties?.l1_mode}</div>}
    </div>
}

export const renderModel23Tooltip = (feature) => {
    const {properties} = feature;

    return <div>
        <div><strong>Modello 2-3</strong></div>
        <div>Stazione: {properties?.station?.code} - {properties?.station?.name}</div>
        {properties?.elevation !== null && <div>Quota: {properties?.elevation} m</div>}
        <div>Data: {properties?.datetime && formatDateTime(properties.datetime)}</div>
    </div>
}

export const renderIncidentTooltip = (feature, incidentRegistry) => {
    const {properties} = feature;

    const category = incidentRegistry?.incidentCategoryV2?.find(c => c.code?.toString() === properties?.incidentCategory?.toString())?.description || properties?.incidentCategory || "";
    const subcategory = incidentRegistry?.incidentSubcategory?.find(s => s.code?.toString() === properties?.incidentSubcategory?.toString())?.description || properties?.incidentSubcategory || "";

    return <div>
        <div><strong>Incidente: {properties?.locationName || properties?.location_name || "N/A"}</strong></div>
        <div>Data: {properties?.date || "N/A"}</div>
        <div>Morti: {properties?.numberOfDeaths ?? "0"}</div>
        <div>Feriti: {properties?.numberOfInjured ?? "0"}</div>
        <div>Incolumi: {properties?.numberOfUninjured ?? "0"}</div>
        <div>Categoria: {category}</div>
        <div>Sottocategoria: {subcategory}</div>
    </div>
}